import React, { createContext, useContext, useState } from "react";

const ModalContext = createContext();

export const ModalProvider = ({ children }) => {
    const [showAgents, setShowAgents] = useState(false);

    const openAgentsModal = () => setShowAgents(true);
    const closeAgentsModal = () => setShowAgents(false);

    return (
        <ModalContext.Provider
            value={{
                showAgents,
                setShowAgents,
                openAgentsModal,
                closeAgentsModal,
            }}
        >
            {children}
        </ModalContext.Provider>
    );
};

export const useModal = () => {
    const context = useContext(ModalContext);
    if (!context) {
        throw new Error("useModal must be used within a ModalProvider");
    }
    return context;
};
